import gql from 'graphql-tag';

export const TariffListQuery = gql`
  query tariffList($where: TariffListWhereInput) {
    tariffList(where: $where) {
      id
      kod
      jmeno
      cena
    }
  }
`;
